import type { WalkthroughConfig } from "../types";

export const membersWalkthrough: WalkthroughConfig = {
  id: "page-members",
  title: "Members & CRM",
  description: "Understand how to manage your member database and CRM.",
  type: "page",
  pageRoute: "/members",
  duration: "1 min",
  category: "pages",
  icon: "Users",
  steps: [
    {
      id: "intro",
      title: "Your Member Database",
      description: "This is the heart of MemberOS. Every member, prospect, and contact lives here with their full history, engagement data, and relationship context.",
      placement: "center",
      animation: "fade",
      icon: "Users",
    },
    {
      id: "profiles",
      title: "Rich Member Profiles",
      description: "Click any member to see their complete profile — engagement score, event history, communication log, billing status, certifications, and more.",
      placement: "center",
      animation: "slide-up",
      icon: "UserCog",
    },
    {
      id: "segments",
      title: "Smart Filtering & Segments",
      description: "Use filters to find members by status, tier, engagement level, join date, or custom fields. Save segments for quick access and targeted communications.",
      placement: "center",
      animation: "fade",
      icon: "Target",
    },
    {
      id: "actions",
      title: "Bulk Actions & Import",
      description: "Import members from CSV, send bulk communications, update tiers, or export data. The member list supports powerful bulk operations.",
      placement: "center",
      animation: "scale",
      icon: "ClipboardList",
      nextLabel: "Got it! ✓",
    },
  ],
};
